import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    job : {},
    job_title: "",
};

const jobSlice = createSlice({
    name:'job',
    initialState,
    reducers : {
        setJob : (state, {payload}) => {
            state.job = payload;
        },
        setJobTitle : (state, {payload}) => {
            state.job_title = payload;
        },
    }
})

export const {setJob, setJobTitle} = jobSlice.actions;

export const getJob = (state) => state.job.job;
export const getJobTitle = (state) => state.job.job_title;

export default jobSlice.reducer;